const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

(function () {
  function removeVioraDuplicateProductPills(root) {
    (root || document).querySelectorAll('.vbb-detail-pills').forEach(function (node) {
      node.remove();
    });
  }

  function bootVioraDuplicateProductPillRemoval() {
    removeVioraDuplicateProductPills(document);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.vbb-detail-pills')) {
            node.remove();
            return;
          }
          removeVioraDuplicateProductPills(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootVioraDuplicateProductPillRemoval, { once: true });
  } else {
    bootVioraDuplicateProductPillRemoval();
  }
})();
